module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedulecard"
  }, [(_vm.item.group_name) ? _c('AppText', {
    staticClass: "appText",
    attrs: {
      "mod": "no-bottom"
    }
  }, [_c('p', [_vm._v("Группа: ")]), _c('b', [_vm._v(_vm._s(_vm.item.group_name))])]) : _vm._e(), (_vm.item.schedule_date_from && _vm.item.schedule_date_to) ? _c('AppText', {
    staticClass: "appText",
    attrs: {
      "mod": "no-bottom"
    }
  }, [_c('p', [_vm._v("Период обучения: ")]), _c('b', [_vm._v(_vm._s(_vm.studyPeriod))])]) : _c('AppText', {
    staticClass: "appText",
    attrs: {
      "mod": "no-bottom"
    }
  }, [_c('p', [_vm._v("Период обучения: ")]), _c('b', [_vm._v("не определён")])]), (_vm.item.size_min >= 0 && _vm.item.size_max) ? _c('AppText', {
    staticClass: "appText",
    attrs: {
      "mod": "no-bottom"
    }
  }, [_c('p', [_vm._v("План приема: ")]), _c('b', [_vm._v(_vm._s(_vm.admissionPlan))])]) : _vm._e(), (_vm.item.approved_orders || _vm.item.studying_orders || _vm.item.initial_orders) ? _c('AppText', {
    staticClass: "appText",
    attrs: {
      "mod": "no-bottom"
    }
  }, [_c('OrdersStat', {
    attrs: {
      "orders_stat": {
        initial: _vm.item.initial_orders,
        approve: _vm.item.approved_orders || 0,
        study: _vm.item.studying_orders || 0
      }
    }
  })], 1) : _vm._e(), _c('ShedulerCalendar', {
    attrs: {
      "group-id": _vm.item.group_id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0fb1f04","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecard/ScheduleCard.vue
// module id = 1b265fd893c6b5993da7
// module chunks = 5